<template>
  <section class="profile">
    <div class="profile_wrapper pb-8">
      <v-flex xs12 sm3 class="profile_first-section">
        <div class="profile_avatar-section my-10">
          <v-avatar color="light-blue darken-2" size="150" class="mb-5">
            <v-icon dark size="60">
              fa-user
            </v-icon>
          </v-avatar>
          <h1>{{ user.userName }}</h1>
        </div>
        <div class="profile_tabs-section">
          <v-list>
            <v-list-item-group v-model="model" color="light-blue darken-4">
              <v-list-item
                v-for="(tab, i) in tabs"
                :key="i"
                @click="setComponent(tab.component)"
              >
                <v-list-item-icon>
                  <v-icon v-text="tab.icon" light></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="tab.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </v-flex>
      <v-flex xs12 sm9 class="profile_second-section">
        <component :is="currentComponent || tabs[0].component"></component>
      </v-flex>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import ProfileSettings from "../../shared/profile_settings.vue";
import ProfileInfo from "../../shared/profile_info.vue";
import ProfileSecurity from "../../shared/profile_security.vue";

export default {
  components: { ProfileInfo, ProfileSettings, ProfileSecurity },
  data() {
    return {
      userEmail: "",
      model: 0,
      menu: false,
      password: "",
      passwordConfirmation: "",
      userName: "",
      currentComponent: "ProfileInfo",
      tabs: [
        { text: "Profile", component: "ProfileInfo", icon: "fa-user" },
        { text: "Settings", component: "ProfileSettings", icon: "fa-cog" },
        {
          text: "Security",
          component: "ProfileSecurity",
          icon: "fa-shield-alt"
        }
      ],
      isFormValid: true,
      userNameRules: [
        userName => !!userName || "User Name is required",
        userName =>
          userName.length < 50 || "Username can not be more than 50 characters"
      ],
      userEmailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid" // eslint-disable-line
      ],
      requiredRule: [v => !!v || "Value is required"],
      passwordRules: [
        //   password => !!password || 'Password is required',
        //   password => password.length >= 4 || "Password must be at least 4 characters",
        confirmation => confirmation === this.password || "Passwords must match"
      ]
    };
  },

  computed: {
    ...mapGetters(["loading", "error", "user", "hasUser"])
  },
  mounted() {
    console.log(this.user);
  },

  watch: {
    user(value) {
      //
      // if user value changes б redirect to home page
      if (value) {
        this.$router.push("/landing");
      }
    }
  },
  methods: {
    setComponent(componentName) {
      this.currentComponent = componentName;
    }
  }
};
</script>

<style lang="scss">
.profile {
  width: 100%;
  height: 100%;

  &_wrapper {
    display: flex;
    flex-wrap: wrap;
    height: 100%;
  }

  &_first-section {
    background-color: white;
    border-right: 1px solid black;
  }

  &_second-section {
    background-color: white;
  }

  &_avatar-section {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
